<template>
  <div id="mainview">
    <el-main>
      <div id="container" @keydown="onKeyDown($event)" @keyup="onKeyUp($event)"></div>
    </el-main>
  </div>
</template>

<script>
import Bus from "../../common/js/bus";
import * as THREE from "three/build/three.module";
import axios from "axios";
// import func from 'vue-editor-bridge';
export default {
  name: "MainView",
  data() {
    return {
      flag: false,
      desc: "3D View",
      O2: {},
      selObj: {},
      SCREEN_WIDTH: 800,
      SCREEN_HEIGHT: 600,
      btnDown: {
        x: 0,
        y: 0,
      },
      mouse: {
        x: 0,
        y: 0,
      },
      mouse_down: {
        x: 0,
        y: 0,
      },
    };
  },
  methods: {
    start3D() {
      let container = document.getElementById("container");
      this.SCREEN_WIDTH = container.clientWidth;
      this.SCREEN_HEIGHT = container.clientHeight;
      var _o2 = document.o2vr;
      _o2.init(container);

      if (this.O2Builder) {
        let builder = this.O2Builder;
        builder.init(_o2);
      }

      // let ppp = this.O2vr.load_o2_scene(
      //   "http://localhost/web/static/builder/scene.json"
      // );
      let ppp = _o2.load_zip_scene(
        "https://o2res.oss-cn-beijing.aliyuncs.com/webgl_scene%2Fwebsite1231.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=2000948660&Signature=lzGrFmC5yBAoPz6NzYXnByy%2BPyE%3D"
      );
      // let ppp = _o2.load_zip_scene(
      //   "https://o2res.oss-cn-beijing.aliyuncs.com/webgl_scene/nonelogo.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001644920384&Signature=7rxd4297BuT8uvOvyVwsT%2Fy1ZWA%3D"
      // );
      {
        let last_mouse_down = Date.now();
        _o2.script = {};
        let scripts = _o2.script;
        _o2.dist_appear = false;
        scripts["init"] = function init() {
          console.log("inited");
          _o2.on_loading_msg("正在下载:", String(Math.ceil(100)), "%");
          _o2.cameraControls.target.set(-190, 2163, -1106);
          _o2.camera.position.set(-413, 2554, -8251);
          _o2.cameraControls.panSpeed = 0.5;
          _o2.cameraControls.maxDistance = 200000;
          _o2.cameraControls.minDistance = 10;
          _o2.cameraControls.maxPolarAngle = Math.PI - Math.PI / 10;
          _o2.cameraControls.minPolarAngle = Math.PI / 10;

          _o2.float_animation = _o2.animation.get_timeline_by_name("float_animation");
          if (_o2.float_animation) _o2.float_animation.play();
          //各个行业的动画
          _o2.home_appear = _o2.animation.get_timeline_by_name("home_appear");
          _o2.military_appear = _o2.animation.get_timeline_by_name("military_appear");
          _o2.dt_appear = _o2.animation.get_timeline_by_name("dt_appear");
          _o2.case_wall_appear = _o2.animation.get_timeline_by_name("case_wall_appear");
          _o2.case_appear = _o2.animation.get_timeline_by_name("case_appear");
          _o2.edu_appear = _o2.animation.get_timeline_by_name("edu_appear");
          _o2.earth_core = _o2.animation.get_timeline_by_name("earth_core");
          _o2.edu_loop = _o2.animation.get_timeline_by_name("edu_loop");
          _o2.software1 = _o2.animation.get_timeline_by_name("software1");
          _o2.software2 = _o2.animation.get_timeline_by_name("software2");
          _o2.software3 = _o2.animation.get_timeline_by_name("software3");
          _o2.software4 = _o2.animation.get_timeline_by_name("software4");
          _o2.obj_click = _o2.search_obj_by_guid2("13A5E015-5856-4B13-B11C-967F8195D1AD");
          _o2.case_screen = _o2.search_obj_by_guid2(
            "FE49C850-D5E5-4ACE-8CB2-6DF89C4FE6F8"
          );
          _o2.screen = _o2.search_obj_by_guid2("E55EDB96-EFCE-4937-AF18-65B99ACB4443");
          _o2.current_solution = "";
          if (_o2.obj_click) {
            _o2.click = _o2.obj_click.clone();
            _o2.scene.add(_o2.click);
            _o2.click.visible = false;
            _o2.click_life = 0;
          }

          _o2.char_urls = [];
          //          _o2.char_urls.push("https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E6%A8%A1%E5%9E%8B/%E5%8D%A1%E9%80%9A%E5%B0%8F%E4%BA%BA.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=360001639123482&Signature=yUveEbREBlrRurfbKfNTl4poH3I%3D");
          _o2.char_urls.push(
            "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%AE%98%E7%BD%91%E5%B0%8F%E4%BA%BA/man1.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=3601642575270&Signature=3CjqCet9UVrx9Eo0ZBDrbMC1RBI%3D"
          );
          _o2.char_urls.push(
            "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%AE%98%E7%BD%91%E5%B0%8F%E4%BA%BA/man2.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001642575284&Signature=2TkdCFOPh6ZFUxDYRa9vWbQ6k1w%3D"
          );
          _o2.char_urls.push(
            "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%AE%98%E7%BD%91%E5%B0%8F%E4%BA%BA/man3.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001642591723&Signature=LI4x%2FFuGoZ5KqdEwKdLJ09bBCnY%3D"
          );
          _o2.char_urls.push(
            "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%AE%98%E7%BD%91%E5%B0%8F%E4%BA%BA/lady1.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=3601642575229&Signature=9Hh5HWiFv%2FGX6hcPkqCz%2BQYoLV4%3D"
          );
          _o2.char_urls.push(
            "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%AE%98%E7%BD%91%E5%B0%8F%E4%BA%BA/lady2.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001642575311&Signature=MUKpA%2FjsE%2FqWATpgOeiXs4aleWQ%3D"
          );
          _o2.char_urls.push(
            "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%AE%98%E7%BD%91%E5%B0%8F%E4%BA%BA/lady3.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001642575325&Signature=dy%2BaFK8nOY7AfqkPrKhOic8lUgs%3D"
          );

          _o2.role_id = 0;
          let url = _o2.char_urls[0];
          console.log(url);
          let promise = _o2.import_object_url(url);
          promise.then((obj3) => {
            if (obj3) {
              let map_user = _o2.add_lable_to_char(obj3, "admin");
              if (map_user && _o2.click) {
                let sprite;
                for (let i = 0; i < _o2.click.children.length; i++) {
                  let obj = _o2.click.children[i];
                  if (obj && obj.name == "Sprite") {
                    sprite = obj;
                    break;
                  }
                }
                if (sprite) {
                  sprite.material.map = map_user;
                }
              }
              _o2.renew_all_uuid(obj3);
              _o2.scene.add(obj3);
              _o2.player = obj3;
              if (obj3.type == "Group") {
                _o2.char = obj3;
              } else {
                for (let i = 0; i < obj3.children.length; i++) {
                  if (obj3.children[i].type == "Group") {
                    _o2.char = obj3.children[i];
                    break;
                  }
                }
              }
              if (_o2.init_play) _o2.init_play();
            }
          });
        };
        function on_close_lable() {
          if (_o2.current_solution != "") {
            active_solution("");
          }
          _o2.active_software("");
        }
        _o2.on_close_lable = on_close_lable;
        function add_lable_to_char(object, name) {
          let canvas = document.createElement("canvas");
          canvas.width = 160;
          canvas.height = 32;
          const drawingContext = canvas.getContext("2d");
          drawingContext.fillStyle = "#000000";
          drawingContext.globalAlpha = 0.8;
          drawingContext.fillRect(0, 0, 160, 32);
          drawingContext.globalAlpha = 1;
          drawingContext.fillStyle = "#ffffff";
          drawingContext.font = "24px Georgia";
          drawingContext.textAlign = "center";
          drawingContext.fillText(name, 80, 24);

          let map = new THREE.CanvasTexture(canvas);
          let sprite = new THREE.Sprite(
            new THREE.SpriteMaterial({ map: map, color: "#ffffff" })
          );
          sprite.position.set(0, 1900, 0);
          sprite.scale.set(600, 120, 1);
          sprite.material.depthWrite = false;
          object.add(sprite);
          return map;
        }
        _o2.add_lable_to_char = add_lable_to_char;
        function update_char_name(obj, name) {
          for (let i = 0; i < obj.children.length; i++) {
            let child = obj.children[i];
            if (child.type == "Sprite") {
              obj.remove(child);
              break;
            }
          }
          _o2.add_lable_to_char(obj, name);
        }
        _o2.update_char_name = update_char_name;
        function add_video_stream_to_char(obj, id) {
          if (!obj) return;
          if (obj.children) {
            for (let i = 0; i < obj.children.length; i++) {
              let e = obj.children[i];
              if (e.name == "videoSprite" && e.isSprite) {
                return;
              }
            }
          }
          let div = document.getElementById(id);
          console.log(div);
          if (div) {
            let arr = div.getElementsByTagName("video");
            console.log(arr.length);
            if (arr && arr.length > 0) {
              let video = arr[0];
              let tex = new THREE.VideoTexture(video);
              let sprite = new THREE.Sprite(
                new THREE.SpriteMaterial({ map: tex, color: "#ffffff" })
              );
              sprite.name = "videoSprite";
              obj.add(sprite);
              sprite.position.set(0, 2500, 0);
              sprite.scale.set(800, 600, 1);
            }
          }
        }
        _o2.add_video_stream_to_char = add_video_stream_to_char;
        function onRemoteStreamAdd(id) {
          if (_o2.players) {
            for (let i = 0; i < _o2.players.length; i++) {
              let e = _o2.players[i];
              if (e.name == id) {
                _o2.add_video_stream_to_char(e.object, id);
              }
            }
          }
        }
        _o2.onRemoteStreamAdd = onRemoteStreamAdd;

        function onLocalStreamAdd() {
          if (_o2.player) {
            _o2.add_video_stream_to_char(_o2.player, "local_stream");
          }
        }
        _o2.onLocalStreamAdd = onLocalStreamAdd;
      }

      ppp.then(() => {
        console.log("load ended");
      });
    },
  },
  created() {},
  mounted() {
    //在模板编译完成后执行
    this.start3D();
  },
};
</script>

<style>
#mainview,
#container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.el-main {
  padding: 0 !important;
  background-color: #e9eef3;
  color: #333;
  height: 100%;
}
</style>
